import { ENTRYPOINT } from '../../../config/entrypoint';
import { API_ROUTES } from '../../../constants/api_routes';
import { CONTENT_TYPE, TOKEN_TYPE } from '../../../constants/constants';
import { deleteData, getData, getHeaders, postData, putData } from '../../../http/request';

export const THERAPY_ACTION_TYPES = {
	GET_THERAPIES_SUCCESS: 'GET_THERAPIES_SUCCESS',
    POST_THERAPY_SUCCESS: 'POST_THERAPY_SUCCESS',
    PUT_THERAPY_SUCCESS: 'PUT_THERAPY_SUCCESS',
    DELETE_WORKER_SUCCESS: 'DELETE_CUSTOMER_SUCCESS',
    UPDATE_THERAPIES_PAGINATION: 'UPDATE_THERAPIES_PAGINATION'
};

const THERAPIES_URL = `${ENTRYPOINT}${API_ROUTES.THERAPIES}`;

const getPaginationParams = ({ page, rowsPerPage }) => {
    return `?page=${page+1}&itemsPerPage=${rowsPerPage}&pagination=true`;
}

const getFilterParams = (params, filters = {}) => {
    const { search } = filters;
    let filterParams = params;
    if (search) {
        filterParams = `${filterParams}&search=${search}`;
    }
    return filterParams;
}

export const getTherapies = (data = { page: 0, rowsPerPage: 10, filters: { } }) => {
    return async (dispatch) => {
        let params = getPaginationParams(data);
        const { filters } = data;
        params = getFilterParams(params, filters);
        const GET_THERAPIES_URL = `${THERAPIES_URL}${params}`;
        const response = await getData(GET_THERAPIES_URL, getHeaders(TOKEN_TYPE.TOKEN, CONTENT_TYPE.LD_JSON));
        dispatch({ type: THERAPY_ACTION_TYPES.GET_THERAPIES_SUCCESS, payload: response['hydra:member'] });
        dispatch({ type: THERAPY_ACTION_TYPES.UPDATE_THERAPIES_PAGINATION, payload: { totalCount: response['hydra:totalItems'] } });
    }
}

export const getTherapy = async (uuid) => {
    const GET_THERAPY_URL = `${THERAPIES_URL}/${uuid}`;
    return await getData(GET_THERAPY_URL);
}

export const postTherapy = (data) => (
    async (dispatch) => {
        const response = await postData(THERAPIES_URL, data, getHeaders(TOKEN_TYPE.TOKEN, CONTENT_TYPE.LD_JSON));
        dispatch({ type: THERAPY_ACTION_TYPES.POST_THERAPY_SUCCESS, payload: response });
        return response;
    }
)

export const putTherapy = (uuid, data) => (
    async (dispatch) => {
        const PUT_WORKERS_URL = `${THERAPIES_URL}/${uuid}`;
        const response = await putData(PUT_WORKERS_URL, data);
        dispatch({ type: THERAPY_ACTION_TYPES.PUT_THERAPY_SUCCESS, payload: response });
        return response;
    }
)

export const deleteTherapy= (uuid) => (
    async () => {
        const DELETE_THERAPY_URL = `${THERAPIES_URL}/${uuid}`;
        await deleteData(DELETE_THERAPY_URL);
        // dispatch({ type: CUSTOMERS_ACTION_TYPES.DELETE_CUSTOMER_SUCCESS, payload: uuid });
    }
)

export const updateTherapiesPagination = ({ rowsPerPage, page = 0, filters }) => {
    return (dispatch) => {
        dispatch({ type: THERAPY_ACTION_TYPES.UPDATE_THERAPIES_PAGINATION, payload: { rowsPerPage, page, filters } });
        dispatch(getTherapies({ page, rowsPerPage, filters }));
    }
}

